<template>
  <div class="my-form-input">
    <label class="my-form-input__label" :for="id" v-if="label">
      {{ label }}
    </label>
    <div class="my-form-input__container" :style="{ width: size ? `${size}px` : '100%' }">
      <span class="my-form-input__icon">
        <slot name="icon" />
      </span>
      <span v-if="prefix" class="my-form-input__prefix">{{ prefix }}</span>
      <input
        :id="id"
        :type="type"
        :placeholder="placeholder"
        v-model="localValue"
        :style="{ fontSize: fontSize ? `${fontSize}px` : '' }"
        @blur="$emit('blur')"
        :required="required"
        :autocomplete="autocomplete"
        :min="min"
        :max="max"
        :step="step"
      />
      <span v-if="sufix" class="my-form-input__sufix">{{ sufix }}</span>
    </div>
  </div>
</template>

<script>
import { nanoid } from "nanoid";

export default {
  name: "input-text-number",

  data() {
    return {
      id: "",
      loading: false,
    };
  },

  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "",
    },
    prefix: {
      type: String,
      default: "",
    },
    sufix: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    fontSize: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: String,
      default: "",
    },
    min: {
      type: [String, Number],
      default: "",
    },
    max: {
      type: [String, Number],
      default: "",
    },
    step: {
      type: [String, Number],
      default: "",
    },
  },

  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit(
          "input",
          this.type === "text" || this.type === "email" ? newValue : Number(newValue)
        );
      },
    },
  },

  mounted() {
    this.id = nanoid();
  },
};
</script>

<style lang="scss" scoped>
.my-form-input {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-bottom: 1px solid #969696;
  padding-bottom: 3px;

  &__label {
    margin-bottom: 0;
  }

  &__container {
    display: flex;
    gap: 1em;
    align-items: center;
  }

  &__prefix {
    font-size: 18px;
    font-weight: 600;
    line-height: inherit;
    color: var(--my-primary);
  }

  &__icon {
    &:empty {
      display: none;
    }
  }

  input {
    width: 100%;
    border: none;
    background: transparent;
    font-size: 18px;
    font-weight: 600;
    line-height: inherit;
    color: var(--my-primary);
    outline: none;
    padding: 0;
    &::placeholder {
      color: var(--my-text-color);
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
  }
}
</style>
